angular.module('shbdeployer.docker').controller('StoridgeSnapshotCreationController', [
  'StoridgeSnapshotService',
  'Notifications',
  '$state',
  function (StoridgeSnapshotService, Notifications, $state) {
    var ctrl = this;

    this.formValues = {};
    this.state = {
      actionInProgress: false,
    };

    this.createSnapshot = function () {
      ctrl.state.actionInProgress = true;
      StoridgeSnapshotService.create(ctrl.volumeId, ctrl.formValues.Description)
        .then(function success() {
          Notifications.success('Готово', 'Снимок успешно создан');
          $state.reload();
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось создать снимок');
        })
        .finally(function final() {
          ctrl.state.actionInProgress = false;
        });
    };
  },
]);
